import React, { useEffect, useState } from "react";
import { useLazyQuery, useQuery } from "react-apollo";
import { Button, ButtonGroup, Card, Heading } from "@shopify/polaris";

// import helper
import { baseHelper } from "lib/helpers";

// import queries
import { GET_FILTER_OPTIONS, GET_ORDER_METRICS } from "app/reporting/apollo/queries";

// import constant
import constant from "lib/constant/constant";

// import component
import { Spinner } from "lib/components";

// import props
import { tabProp } from "app/reporting/modules/operator/props";

// import Filters
import { EmptyReportingState, ReportingFilters } from "app/reporting/modules/generic/components";

// import Graph
import { BarGraph, PieGraph } from "app/reporting/modules/generic/graph";

const { MONTHS } = constant;

const OrdersTab = (props) => {
  const { reportingConfig } = props;
  const [chartType, setChartType] = useState("barChart");
  const [filterBy, setFilterBy] = useState("");
  const [filterOptions, setFilterOptions] = useState();
  const [graphData, setGraphData] = useState([]);
  const [selectedDates, setSelectedDates] = useState();
  const [selectedFilterOption, setSelectedFilterOption] = useState();
  const [timePeriod, setTimePeriod] = useState();

  const handleTimePeriod = (value) => {
    setTimePeriod(value);
    setSelectedDates(null);
  };

  const [getReporting, { loading, data: orderReportingData }] = useLazyQuery(GET_ORDER_METRICS);
  const { data: filterOptionsData } = useQuery(GET_FILTER_OPTIONS);

  const filterOptionsResponse = baseHelper.getResponseData(filterOptionsData, constant.gql.GET_FILTER_OPTIONS) || [];

  useEffect(() => {
    const response = baseHelper.getResponseData(orderReportingData, constant.gql.GET_ORDER_METRICS);
    if (response) {
      const orderResponse = response.order.map((item) => ({ ...item, month: MONTHS[item.month - 1] }));
      setGraphData(orderResponse);
    }
  }, [orderReportingData]);

  useEffect(() => {
    const submitQuery = () => {
      const inputData = {
        filter: {
          days: parseInt(timePeriod, 10),
          dateRange: selectedDates,
          filterBy,
          filterOptionValue: selectedFilterOption,
        },
      };
      getReporting({
        variables: {
          input: inputData,
        },
      });
    };
    if (filterBy && selectedFilterOption && (timePeriod || selectedDates)) submitQuery();
  }, [filterBy, getReporting, selectedDates, selectedFilterOption, timePeriod]);

  const submitReportingQuery = (value) => {
    setTimePeriod(null);
    setSelectedDates(value);
  };

  return (
    <Card.Section>
      <div style={{ display: "flex", marginBottom: "15px" }}>
        <Heading>Orders Metric</Heading>
        <div style={{ marginLeft: "auto" }}>
          <ButtonGroup segmented connectedTop>
            <Button size="slim" primary={chartType === "barChart"} onClick={() => setChartType("barChart")}>
              Bar chart
            </Button>
            <Button size="slim" primary={chartType === "pieChart"} onClick={() => setChartType("pieChart")}>
              Pie chart
            </Button>
          </ButtonGroup>
        </div>
      </div>
      <ReportingFilters
        filterOptions={filterOptions}
        filterOptionsResponse={filterOptionsResponse}
        handleTimePeriod={handleTimePeriod}
        reportingConfig={reportingConfig}
        selectedFilterOption={selectedFilterOption}
        setFilterBy={setFilterBy}
        setFilterOptions={setFilterOptions}
        setSelectedDates={setSelectedDates}
        setSelectedFilterOption={setSelectedFilterOption}
        submitReportingQuery={submitReportingQuery}
        timePeriod={timePeriod}
      />
      {loading && (
        <div style={{ top: "60%", "min-height": "500px" }}>
          <Spinner />
        </div>
      )}
      {!loading && graphData?.length > 0 && chartType === "barChart" && (
        <BarGraph data={graphData} xDataKey="month" barDataKey="count" />
      )}
      {!loading && graphData?.length > 0 && chartType === "pieChart" && (
        <PieGraph data={graphData} labelSuffix="month" dataKey="count" />
      )}
      {!loading && !graphData?.length && <EmptyReportingState />}
    </Card.Section>
  );
};

OrdersTab.propTypes = tabProp.type;

export default OrdersTab;
